import React from "react";

type Props = {
  href: string;
  text: string;
  title: string;
};

const TwitterButton: React.FC<Props> = (props) => {
  const { href, text, title } = props;
  return (
    <a
      href={`http://twitter.com/share?url=${href}&text=${title}`}
      className="link-hover-none hover:bg-[#000] before:mr-[10px] left-icon icon-twitter-white !bg-[#000] h-[50px] font-raleway rounded-default block flex items-center justify-center w-full text-white text-sm"
    >
      {text}
    </a>
  );
};

export default TwitterButton;
